// extracted by mini-css-extract-plugin
module.exports = {"legend":"geoStyles_legend__fl6Uo","legend2":"geoStyles_legend2__1iJI1","tooltip":"geoStyles_tooltip__3UXf_","iconBtn":"geoStyles_iconBtn__3tfLQ"};